import React, { useEffect } from 'react';
import { ImagePlaceholder } from '../ui/Primitives.jsx';
import { fillTemplate } from '../../lib/helpers.js';

// Mapa-múndi de prova social. totalUsuarios deve vir de uma métrica real do
// backend (contagem de usuários ativos) — nunca um número hardcoded que
// nunca muda, como costuma acontecer nesse tipo de tela em apps concorrentes.
export default function SocialProofMap({ step, gender, totalUsuarios = 0, onNext, autoAdvanceMs = 2200 }) {
  useEffect(() => {
    const t = setTimeout(onNext, autoAdvanceMs);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="phone-frame flex flex-col safe-top safe-bottom px-5 pt-8">
      <h1 className="font-display text-2xl font-extrabold leading-snug mb-8">
        {fillTemplate(step.headlineTemplate, { totalUsuarios: totalUsuarios.toLocaleString('pt-BR') })}
      </h1>

      <div className="flex-1 relative">
        <WorldDotsSvg />
        <div className="absolute left-[28%] top-[45%] -translate-x-1/2 -translate-y-full">
          <ImagePlaceholder
            src={typeof step.userAvatar === 'object' ? step.userAvatar[gender] : step.userAvatar}
            className="w-10 h-10 rounded-full object-cover border-2 border-cyan"
            label="👤"
          />
        </div>
      </div>

      <div className="py-6">
        <div className="flex justify-between text-sm mb-2">
          <span className="font-display font-bold">{step.progressPercent}%</span>
          <span className="text-ink-muted">{step.progressLabel}</span>
        </div>
        <div className="w-full h-1.5 bg-surface-2 rounded-full overflow-hidden">
          <div className="h-full bg-cyan-gradient" style={{ width: `${step.progressPercent}%` }} />
        </div>
      </div>
    </div>
  );
}

function WorldDotsSvg() {
  // Grade de pontos simples representando o mapa — substituível por um mapa
  // SVG real do mundo depois, sem mudar a lógica do componente.
  const dots = [];
  for (let row = 0; row < 14; row++) {
    for (let col = 0; col < 20; col++) {
      const active = Math.random() > 0.72;
      dots.push(
        <circle
          key={`${row}-${col}`}
          cx={col * 16 + 8}
          cy={row * 16 + 8}
          r={2.2}
          className={active ? 'fill-cyan' : 'fill-surface-2'}
        />
      );
    }
  }
  return (
    <svg viewBox="0 0 320 224" className="w-full h-full">
      {dots}
    </svg>
  );
}
